    :host([sticky]) {
        position: sticky;
        top: 0;
        z-index: 1;
    }